import { combineReducers } from 'redux';

import { authentication } from './authentication.reducer';
import { users } from './users.reducer';
import { alert } from './alert.reducer';
import { seller } from './seller.reducer';
import { countries } from './sellers/country.reducer';
import { addSeller } from './sellers/addSeller.reducer';
import { sellerAdmins } from './sellers/sellerAdmin.reducer';
import { credits } from './sellers/credits.reducer';
import { updateSeller } from './sellers/editSeller.reducer';
import { addSellerAdmins } from './sellers/addSellerAdmin.reducer';
import { organisations } from './sellers/organisations.reducer';
import { organisation } from './organisation.reducer';
import { addOrganisation } from './organisation/addOrganisation.reducer';
import { instrumentListFull } from './organisation/getInstrumentListFull.reducer';
import { organisationCredits } from './organisation/credits.reducer';
import { organisationAdmins } from './organisation/admins.reducer';
import { orgImageUpload } from './organisation/imageUpload.reducer';
import { deleteOrgState } from './organisation/deleteOrganisation.reducer';
import { managaBatchList } from './organisation/manageBatchList.reducer'
import { editOrgState } from './organisation/editOrganisation.reducer';
import { makeOrganisationAdmins } from './organisation/makeOrgAdmin.reducer';
import { removeOrganisationAdmins } from './organisation/removeOrgAdmin.reducer';
import { deleteOrganisationAdmins } from './organisation/deleteOrgAdmin.reducer';
import { addBatch } from './organisation/addBatchOrg.reducer';
import { AddOrganisationAdmins } from './organisation/addOrgAdmin.reducer';
import { deleteBatch } from './organisation/deleteBatchOrg.reducer'
import { batchDetail } from './organisation/batchDetails.reducer'
import { allotUnallotBatch } from './organisation/allotUnallotBatchOrg.reducers'
import { updateMinRespondence } from './organisation/updateMinResp.reducer'
import { participantsList } from './organisation/getParticipantsList.reducer'
import { addParticipents } from './organisation/addParticipents.reducer'
import { allotAssess } from './organisation/allotassesment.reducer'
import { disablePi } from './organisation/disablePi.reducer'
import { enablePi } from './organisation/enablePi.reducer'
import { addOrgMandate } from './organisation/addOrgMandate.reducer'
import { allotBatch } from './organisation/allotBatch.reducer'
import { removeFromBatch } from './organisation/removeFromBatch.reducer'
import { enableReports } from './organisation/enableReport.reducer'
import { disableReport } from './organisation/disableReport.reducer'
import { unsubmitAssessment } from './organisation/unsubmittedAssessment.reducer'
import { setExpiryDate } from './organisation/setExpiryDate.reducer'
import { deleteReport } from './organisation/deleteReport.reducer'
import { setReportTheme } from './organisation/setReportTheme.reducer'
import { getReportTheme } from './organisation/getThemeReport.reducer'
import { instrumentList } from './organisation/instrumentList.reducer'
import { setSellerAndOrgId } from './organisation/setID.reducer'
import { getCustomReportState } from './organisation/customReport.reducer'
import { orgEditRelation } from './organisation/editRelation.reducer';
import { addAnalyticsOrgAdmin } from './organisation/addAnalyticsOrgAdmin.reducer';
import { removeAnalyticsOrgAdmin } from './organisation/removeAnalyticsOrgAdmin.reducer';
import { downloadDemographicData } from './organisation/demographicDownload.reducer';


import { sellCredit } from './sellers/sellCredit.reducer';
import { revokeCredit } from './sellers/revokeCredit.reducer';
import { sellerImage } from './sellers/sellerImage.reducer';
import { removeSellerImage } from './sellers/removeSellerImage.reducer';
import { orgImageRemove } from './organisation/orgImageRemove.reducer';
import { deleteSeller } from './sellers/deleteSeller.reducer';
import { makePrimaryAdmin } from './sellers/sellerAdmin/makePrimaryAdmin.reducer';
import { removeSellerAdmin } from './sellers/sellerAdmin/removeSellerAdmin.reducer';

import { relationGroupTable } from './relationGroups/relationGroupsTable.reducer';
import { addRelationGroup } from './relationGroups/addRelationGroup.reducer';
import { editRelationGroup } from './relationGroups/editRelationGroup.reducer';
import { editRelation } from './relationGroups/editRelation.reducer';
import { deleteRelation } from './relationGroups/deleteRelation.reducer';
import { userRelationGroupReducer } from './relationGroups/userRelationGroup.reducer';

import { developmentPlan } from './developmentPlan/developmentPlan.reducer';
import { updateRespondentsDevelopmentPlan } from './developmentPlan/updateRespondents.reducer';
import { relationList } from './developmentPlan/getRelationList.reducer';
import { updateRelationListDevelopmentPlan } from './developmentPlan/updateRelationList.reducer';
import { getBatchAssessmentSummary } from './assessmentSummary/getBatchList.reducer';
import { getAssessmentSummary } from './assessmentSummary/getAssessment.reducer';
import { getAssessmentReport } from './assessmentSummary/getAssessmentReport.reducer';

import { getUserProfile } from './userProfile/getUserProfile.reducer';
import { getDemographicData } from './userProfile/getDemographicData.reducer';
import { updateBasicInfo } from './userProfile/updateBasicInfo.reducer';
import { updateAdditionalInfo } from './userProfile/updateAdditionalInfo.reducer';
import { updateDobInfo } from './userProfile/updateDobInfo.reducer';

import { dashBoardRed } from './dashBoard/dashBoard.reducer'
import { AsessorGroupList } from './dashBoard/assesserGroupList.reducer'
import { removeAssessor } from './dashBoard/removeAssessment.reducer'
import { invitePost } from './dashBoard/invitePost.reducer'
import { editAsessmentReducer } from './dashBoard/editAssessment.reducer'
import { sendRemainderIndividualReducer } from './dashBoard/sendRemainderIndividual.reducer'
import { sendRemainderBulkReducer } from './dashBoard/sendRemainderBulk.reducer'
import { submitSingleRaterAssessment } from './assessments/submitSingleRaterAssessment.reducer';


import { final_assessment_reducer } from './dashBoard/final_assessment.reducer';

// Allotment Summary
import { getAllotmentSummary } from './allotmentSummary/allotmentSummary.reducer';

// Assessments module
import { getAssessmentList } from './assessments/getAssessments.reducer';
import { respondentsAssessmentReducer } from './assessments/respondentsAssessment.reducer';

//modal reducer
import { modalStatus } from './organisation/modalStatus.reducer';


//upload demographic data
import { demoGraphicCsvUpload } from './uploadDemoGraphic/demoGraphicCsvUpload.reducer';

//upload assessment csv
import { uploadAssessment } from './organisation/uploadCsv/uploadAssessment.reducer';

 import {uploadAssessmentResponses} from './organisation/uploadCsv/uploadAssessmentResponses.reducer';
 import {uploadAssessmentResponsesResultList} from './organisation/uploadCsv/uploadAssessmentResponsesResultList.reducer';
 import {uploadAssessmentResponsesResultView} from './organisation/uploadCsv/uploadAssessmentResponsesResultView.reducer'
//upload respondent csv
import { uploadRespondent } from './organisation/uploadCsv/uploadRespondent.reducer';

//group report api's
import { groupReportOrganisationAsessment } from './organisation/groupReport.reducer';
import { groupReportAssessorList } from './organisation/groupReportAssessorList.reducer';

// change password
import { changePasswordReducer } from './userProfile/changePassword.reducer';

// set password
import { setPasswordReducer } from './userProfile/setPassword.reducer';

//SET PASSWORD MAIN
import { setPasswordReducerMain } from './set-password/set-password.reducer';

import { createProfileReducer } from './userProfile/createProfile.reducer';
import { isSignUpCompletedReducer } from './userProfile/isSignUpCompleted.reducer';
import { forgotPasswordReducer } from './userProfile/forgotPassword.reducer';

// manage metric
import { ManageMetricList } from './organisation/manageMetric/getManageMetricList.reducer';
import { AddManageMetric } from './organisation/manageMetric/addManageMetric.reducer';
import { UpdateManageMetric } from './organisation/manageMetric/updateManageMetric.reducer';
import { DeleteManageMetric } from './organisation/manageMetric/deleteManageMetric.reducer';
import { ManageCompetencyList } from './organisation/manageMetric/getCompetency.reducer';
import { ManageAttributeList } from './organisation/manageMetric/getAttributeList.reducer';
import { CompetencyMetricPrefill } from './organisation/manageMetric/competencyMetricPrefill.reducer';

// role fitment report
import { getHolderAndOrganisationCompetency } from './organisation/roleFitmentReport/getHolderAndOrganisationCompetency.reducer';
import { getAllottedOrganistionFitments } from  './organisation/roleFitmentReport/getAllottedOrganistionFitments.reducer';
import { getOrganistionFitmentsList } from './organisation/roleFitmentReport/getOrganisationFitmentList.reducer';

// Demographic Data
import { addDemographicData } from './demographicData/addDemographicData.reducer';
import { updateOrDeleteDemographicData } from './demographicData/updateOrDeleteDemographicData.reducer';

// CustomMail
import { sendRemainderReducer } from './customEmails/sendRemainder.reducer';
import { sendCustomMailReducer } from './customEmails/sendCustomMail.reducer';

// csvDownloadReducer

import { csvDownloadReducer } from './csvDownload/csvDownload.reducer';

import { getReportContent } from './reportContent/getReportContent.reducer';
import { getOrientationList } from './reportContent/getOrientationList.reducer';
import { getSlotList } from './reportContent/getSlotList.reducer';


//worksheet reducers
import { saveWorksheetReducer } from './workSheet/saveWorkSheet.reducer';
import { shareWorksheetReducer } from './workSheet/shareWorkSheet.reducer';
import { removeSharingWorksheetReducer } from './workSheet/removeSharing.reducer';
import { getWorksheetReducer } from './workSheet/getWorkSheets.reducer';
import { updateWorksheetReducer } from './workSheet/updateWorksheet.reducer';
import { getSharedUsersReducer } from './workSheet/getSharedUsers.reducer';
import { saveCommentReducer } from './workSheet/saveComment.reducer';
import { getCommentListReducer } from './workSheet/getCommentList.reducer';
import { worksheetOrientationReducer } from './workSheet/orientationWorksheet.reducer';
import { worksheetOrientationReducerSingle } from './workSheet/orientationWorksheet.reducer';
import { getWorkSheetDetailsReducer } from './workSheet/getWorksheetDetails.reducer';
import { getSharedWithUsersReducer } from './workSheet/getSharedWithUsers.reducer';
import { getWeakAreaReducer } from './workSheet/getWeakArea.reducer';


//bulk download
import { addBulkDownloadReducer } from './organisation/bulkDownload/addBulkDownload';
import { removeBulkDownloadReducer } from './organisation/bulkDownload/removeBulkDownload';
import { checkBulkDownloadReducer } from './organisation/bulkDownload/checkBulkDownload';
import { reportBulkDownloadReducer } from './organisation/bulkDownload/downloadBulkReport';
import { resetAssessment } from './organisation/resetAssessment.reducer';


const rootReducer = combineReducers({
  authentication,
  users,
  alert,
  countries,

  // SELLERS
  seller,
  addSeller,
  updateSeller,
  deleteSeller,
  sellerAdmins,
  addSellerAdmins,
  makePrimaryAdmin,
  removeSellerAdmin,
  credits,
  sellCredit,
  revokeCredit,
  sellerImage,
  removeSellerImage,
  organisations,
  setSellerAndOrgId,

  // RELATION GROUPS
  relationGroupTable,
  addRelationGroup,
  editRelationGroup,
  editRelation,
  deleteRelation,
  userRelationGroupReducer,

  //development plan
  developmentPlan,
  updateRespondentsDevelopmentPlan,
  relationList,
  updateRelationListDevelopmentPlan,

  //organisation
  orgImageRemove ,
  organisation,
  addOrganisation,
  organisationCredits,
  organisationAdmins,
  orgImageUpload,
  deleteOrgState,
  makeOrganisationAdmins,
  removeOrganisationAdmins,
  deleteOrganisationAdmins,
  editOrgState,
  AddOrganisationAdmins,
  orgEditRelation,
  addAnalyticsOrgAdmin,
  removeAnalyticsOrgAdmin,
  instrumentListFull,

  //Manage Batch
  managaBatchList,
  addBatch,
  addOrgMandate,
  deleteBatch,
  batchDetail,
  allotUnallotBatch,
  updateMinRespondence,
  resetAssessment,

  //Participents
  participantsList,
  addParticipents,
  allotAssess,
  instrumentList,
  enablePi,
  disablePi,

  //Manage Batch unalloted 
  enableReports,
  allotBatch,
  removeFromBatch,
  disableReport,
  unsubmitAssessment,
  setExpiryDate,
  deleteReport,
  setReportTheme,
  getReportTheme,
  getCustomReportState,


  //modal reducer
  modalStatus,

  //Assessment Summary
  getBatchAssessmentSummary,
  getAssessmentSummary,
  getAssessmentReport,

  // Allotment Summary
  getAllotmentSummary,

  // USER PROFILE
  getUserProfile,
  getDemographicData,
  updateBasicInfo,
  updateAdditionalInfo,
  updateDobInfo,
  changePasswordReducer,
  setPasswordReducer,
  createProfileReducer,
  isSignUpCompletedReducer,
  forgotPasswordReducer,

  //dashBoard
  dashBoardRed,
  AsessorGroupList,
  removeAssessor,
  invitePost,
  final_assessment_reducer,

  // Assessments
  getAssessmentList,
  editAsessmentReducer,
  sendRemainderIndividualReducer,
  sendRemainderBulkReducer,
  respondentsAssessmentReducer,
  submitSingleRaterAssessment,

  //upload demographic data
  demoGraphicCsvUpload,

  // manage metric
  ManageMetricList,
  AddManageMetric,
  UpdateManageMetric,
  DeleteManageMetric,
  ManageCompetencyList,
  ManageAttributeList,
  CompetencyMetricPrefill,

  // role fitment
  getHolderAndOrganisationCompetency,
  getAllottedOrganistionFitments,
  getOrganistionFitmentsList,

  //group report
  groupReportOrganisationAsessment,
  groupReportAssessorList,

  // Demograpic data
  addDemographicData,
  updateOrDeleteDemographicData,

  //set password
  setPasswordReducerMain,

  // custom emails
  sendRemainderReducer,
  sendCustomMailReducer,

  // csvDownloadReducer 
  csvDownloadReducer,

  //upload assessment
  uploadAssessment,

  // upload assessment responses
  uploadAssessmentResponses,

  //upload assessment responses result list
  uploadAssessmentResponsesResultList,

  // upload assessment responses result view
  uploadAssessmentResponsesResultView,

  //upload respondent
  uploadRespondent,

  // getReportContent
  getReportContent,
  getSlotList,
  getOrientationList,

  // workSheet
  getWorksheetReducer,
  saveWorksheetReducer,
  shareWorksheetReducer,
  removeSharingWorksheetReducer,
  updateWorksheetReducer,
  getSharedUsersReducer,
  saveCommentReducer,
  getCommentListReducer,
  worksheetOrientationReducer,
  worksheetOrientationReducerSingle,
  getWorkSheetDetailsReducer,
  getSharedWithUsersReducer,
  getWeakAreaReducer,


  //demographic data
  downloadDemographicData,


  //bulk download
  addBulkDownloadReducer,
  removeBulkDownloadReducer,
  checkBulkDownloadReducer,
  reportBulkDownloadReducer
  
})


export default rootReducer;


// WEBPACK FOOTER //
// ./src/_reducers/index.js